export default __webpack_public_path__ + "static/media/services6.cad5df65.jpg";